/* =========================================================================
   HIRA MODA – Artikelpreis im Warenkorb-Drawer = Menge x Stueckpreis
   -------------------------------------------------------------------------
   Zeigt neben jedem Artikel den Zeilenpreis (Menge * Preis) statt des
   Stueckpreises und aktualisiert ihn sofort bei +/- (ohne Neuladen).
   Rein additiv, Design bleibt unveraendert.
   ========================================================================= */
(function () {
  if (window.__hmLinePrice) return;
  window.__hmLinePrice = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

  function money(cents) {
    var v = (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return '€' + v; // z. B. €159,80
  }

  function setText(el, txt) {
    if (el && el.textContent.trim() !== txt) el.textContent = txt;
  }

  function priceEl(details) {
    // direkter Preis-Container (nicht die Varianten-Optionen im <dl>)
    var disc = details.querySelector(':scope > .cart-item__discounted-prices');
    if (disc) return { disc: disc };
    var opts = details.children;
    for (var i = 0; i < opts.length; i++) {
      if (opts[i].classList && opts[i].classList.contains('product-option')) {
        // Preis-Zeile enthaelt ein Waehrungszeichen; Varianten stehen im <dl>
        if (/[0-9]/.test(opts[i].textContent) && /[€$£]/.test(opts[i].textContent)) {
          return { plain: opts[i] };
        }
      }
    }
    return null;
  }

  function update() {
    var drawer = document.querySelector('#CartDrawer');
    if (!drawer) return;
    fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var rows = drawer.querySelectorAll('.cart-item');
        (cart.items || []).forEach(function (it, i) {
          var row = rows[i];
          if (!row) return;
          var details = row.querySelector('.cart-item__details');
          if (!details) return;
          var target = priceEl(details);
          if (!target) return;
          if (target.disc) {
            setText(target.disc.querySelector('.cart-item__old-price'), money(it.original_line_price));
            setText(target.disc.querySelector('.cart-item__final-price'), money(it.final_line_price));
          } else if (target.plain) {
            setText(target.plain, money(it.final_line_price));
          }
        });
      })
      .catch(function () {});
  }

  var timer = null;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; update(); }, 120);
  }

  function boot() {
    schedule();
    var cd = document.querySelector('cart-drawer');
    if (cd && window.MutationObserver) {
      new MutationObserver(function () { schedule(); })
        .observe(cd, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
